/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	AdminKeyEligibilityQuery$data as AdminKeyEligibilityQuery,
	AdminKeyEligibilityQuery$variables as AdminKeyEligibilityQueryVariables,
} from '../__generated__/AdminKeyEligibilityQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { AdminKeyEligibilityQuery$data } from '../__generated__/AdminKeyEligibilityQuery.graphql.ts';
export type AdminKeyEligibilityQuery_tenant_Tenant = NonNullable<AdminKeyEligibilityQuery$data['tenant']>;
export type AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext_editions_Editions = NonNullable<AdminKeyEligibilityQuery$data['confluenceTenantContext']>['editions'];
export type AdminKeyEligibilityQuery_confluenceTenantContext_ConfluenceTenantContext = NonNullable<AdminKeyEligibilityQuery$data['confluenceTenantContext']>;
export type AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser_roles_GraphQLConfluenceUserRoles = NonNullable<NonNullable<NonNullable<AdminKeyEligibilityQuery$data['user']>['confluence']>['roles']>;
export type AdminKeyEligibilityQuery_user_AtlassianUser_confluence_ConfluenceUser = NonNullable<NonNullable<AdminKeyEligibilityQuery$data['user']>['confluence']>;
export type AdminKeyEligibilityQuery_user_AtlassianUser = NonNullable<AdminKeyEligibilityQuery$data['user']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}

